let knownErrors = {
   'unknown': async (error) => {
      console.log('Error',error)
      if(error.code){
         $notify('error', `Error - ${error.code}`, error.msg)
      }else{
         $notify('error', 'Unknown Error', 'An Error has Occured')
      }
   },
   '5003': async (error) => {
      $notify('error', 'Token Expired', 'Please log in again to get a new token')
      window.location.href = '/';
   },
   '5002': async (error) => {
      $notify('error', 'User not Found', 'Please log in again.')
      window.location.href = '/';
   },
}

export default class ErrorHandler {
   constructor(router) {
      this.router = router;
   }

   async handleError(err) {
       console.log("Handling error ...",err)
      if (err && err.error && err.error.code) {
         let code = err.error.code.toString()
         let errAction = knownErrors[code]

         if (errAction) {
            await errAction(err.error)
         } else {
            await knownErrors['unknown'](err.error)
         }
      } else {
         console.log(err.error)
         if (err.error) {
            if(err.error.code){
               $notify('error', `Error - ${err.error.code}`, err.error.msg || err.error.message)
            }else{
               $notify('error', 'Error', err.error.msg || err.error.message)
            }
         } else if(err.result.error){
            err = err.result.error
            if(err.code == 422){
               let message = ''
               for (let i = 0; i < err.details.error_fields.length; i++) {
                  let field = Object.entries(err.details.error_fields[i])[0];
                  
                  console.log(field)
                  message += `<b>${field[0]}</b> - ${field[1].message} </br>`
               }

               $notify('error', 'Validation Error', message)
            }
         }else {
            $notify('error', 'Error', 'An Error Occured.')
         }
      }
   }
}